import React, { useEffect, useState } from 'react';
import { PageLayout } from '../components/page-layout';
import { AuctionResultsTable } from '../components/auction/auction-results-table';
import { AcceptedOffersTable } from '../components/auction/accepted-offers-table';
import PremPlayersProvider from "../providers/premplayers-provider";
import { getAuctionResults } from '../services/auction-results.service';
import { getCurrentWindowAcceptedOffersResource } from '../services/offers.service';
import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

export const AuctionResultsPage = () => {
  const [auctionResults, setAuctionResults] = useState([]);
  const [acceptedOffers, setAcceptedOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [acceptedOffersError, setAcceptedOffersError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);

        const [auctionResultsResponse, acceptedOffersResponse] = await Promise.all([
          getAuctionResults(),
          getCurrentWindowAcceptedOffersResource(),
        ]);

        if (auctionResultsResponse.data) {
          setAuctionResults(auctionResultsResponse.data.Items);
        }
        if (auctionResultsResponse.error) {
          setError(auctionResultsResponse.error);
        }

        if (acceptedOffersResponse.data) {
          setAcceptedOffers(acceptedOffersResponse.data.offers);
        }
        if (acceptedOffersResponse.error) {
          setAcceptedOffersError(acceptedOffersResponse.error);
        }

      } catch (err) {
        setError(err);
        setAcceptedOffersError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  if (loading) {
    return (
      <PageLayout>
        <Box sx={{ mb: 4 }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 350 }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{minWidth:'120px', padding: '6px 14px'}}><Skeleton width="80%" /></TableCell>
                  <TableCell sx={{padding: '6px 14px'}}><Skeleton width="80%" /></TableCell>
                  <TableCell sx={{padding: '6px 14px'}}><Skeleton width="80%" /></TableCell>
                  <TableCell sx={{padding: '6px 14px'}}><Skeleton width="80%" /></TableCell>
                  <TableCell sx={{padding: '6px 14px'}}><Skeleton width="80%" /></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[...Array(10)].map((_, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{padding: '16px 14px'}}><Skeleton /></TableCell>
                    <TableCell sx={{padding: '16px 14px'}}><Skeleton /></TableCell>
                    <TableCell sx={{padding: '16px 14px'}}><Skeleton /></TableCell>
                    <TableCell sx={{padding: '16px 14px'}}><Skeleton /></TableCell>
                    <TableCell sx={{padding: '16px 14px'}}><Skeleton /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </PageLayout>
    );
  }

  if (error || acceptedOffersError) {
    return (
      <div>
        {error && <div>Error fetching auction results: {error.message}</div>}
        {acceptedOffersError && <div>Error fetching accepted offers: {acceptedOffersError.message}</div>}
      </div>
    );
  }

  return (
    <PageLayout>
      <PremPlayersProvider>
        <AcceptedOffersTable offers={acceptedOffers} />
      </PremPlayersProvider>
      <Box sx={{ mb: 4 }}>
        <PremPlayersProvider>
          <AuctionResultsTable results={auctionResults} />
        </PremPlayersProvider>
      </Box>
    </PageLayout>
  );
};